import { Component, OnDestroy, OnInit } from '@angular/core';
import { NotificationService } from "src/app/Service/notification.service";
import { OtherService } from "src/app/Service/other.service";
import { Tile as TileLayer } from 'ol/layer';
import { Point } from "ol/geom";
import { BingMaps, Cluster, Vector, XYZ } from "ol/source";
import { MapService } from "src/app/Service/map.service";
import { Circle, Fill, Stroke, Style, Text } from "ol/style";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { GurdServiceService } from "src/app/Service/gurd-service.service";
import "ol/ol.css";
import Map from 'ol/Map';
import View from 'ol/View';
import VectorLayer from 'ol/layer/Vector';
import Feature from 'ol/Feature';
import OSM from 'ol/source/OSM';
import axios from "src/app/Service/axios";
import AnimatedCluster from "ol-ext/layer/AnimatedCluster";
import SelectCluster from "ol-ext/interaction/SelectCluster";
import momentJalaali from "moment-jalaali";
import * as olProj from 'ol/proj';
import VectorSource from "ol/source/Vector";
import { Router } from '@angular/router';
import { ChartContext } from 'src/app/shared/chart/chart.models';
import { FisheriesChartKey } from './fisheries-dashbord.models';
import { parseCategoryChartData, parseChartTree } from 'src/app/shared/chart/chart-data.utils';
declare let $: any;

@Component({

  selector: 'app-fisheries-dashbord',

  templateUrl: './fisheries-dashbord.component.html',

  styleUrls: ['./fisheries-dashbord.component.css']

})

export class FisheriesDashbordComponent implements OnInit, OnDestroy {

  location: any = [51.3833554, 35.6770113];

  map: any = {};

  tiMobileType: any = -1;

  iMobileDomain: number = -1;

  domain: any;

  groupCar: any = [];

  dataFrom: FormGroup = this.formBuilder.group({

    date: momentJalaali().subtract(1, 'jMonth').valueOf(),

  });

  dataTo: FormGroup = this.formBuilder.group({

    date: new Date().valueOf(),

  });

  strSTime: FormControl = new FormControl("00:00");

  strETime: FormControl = new FormControl("23:59");

  source: any;

  vector: any;

  layers: any = [];

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  constructor(
    private notifyService: NotificationService,
    private router: Router,
    private otherService: OtherService,
    private mapService: MapService,
    private formBuilder: FormBuilder,
    private gurdService: GurdServiceService,
  ) {}

  filtersOpen = false;
  loading = false;
  private destroyed = false;
  powerChart: ChartContext = { type: 'pie', title: 'تعداد شناورها به تفکیک توان', data: [], loading: true };
  fuelConsumptionChart: ChartContext = { type: 'bar', title: 'پر مصرف ترین شناورها', zoom: true, data: [], loading: true };
  prolificBoatsChart: ChartContext = { type: 'bar', title: 'پر عملکردترین شناورها', zoom: true, data: [], loading: true };
  boatStatisticsChart: ChartContext = { type: 'tree', title: 'وضعیت شناورها', data: [], loading: true };
  boatStatusChart: ChartContext = { type: 'tree', title: 'شناورها به تفکیک محدوده جغرافیایی', data: [], loading: true };

  ngOnInit(): void {
    void this.search();
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    this.map?.dispose?.();
  }

  goBack(): void {
    void this.router.navigateByUrl('/');
  }

  showHelp(): void {
    $.confirm({
      title: 'راهنمای داشبورد شیلات نگر',
      content: 'از بخش فیلتر، بازه زمانی، حوزه خدمت و نوع شناور را انتخاب و به روز رسانی کنید. برای مشاهده زیرمجموعه‌ها روی شاخه‌های نمودار درختی کلیک کنید.',
      buttons: { close: { text: 'بستن', btnClass: 'btn-primary' } },
    });
  }

  async search(): Promise<void> {
    if (this.loading) return;
    this.filtersOpen = false;
    this.loading = true;
    this.otherService.Showspinner();
    try {
      const results = await Promise.allSettled([
        this.getDomain(),
        this.getGroup(),
        this.loadChart('boatStatisticsChart', 'Boat_Statistics', '34', true),
        this.loadChart('boatStatusChart', 'Boat_Status', '34', true),
        this.loadChart('fuelConsumptionChart', 'Report_MobilesFullReport', '34', true),
        this.loadChart('prolificBoatsChart', 'Boat_Prolific', '34', true),
        this.loadChart('powerChart', 'Report_PowerStatus', '57'),
      ]);
      if (!this.destroyed) {
        results.push(...await Promise.allSettled([this.initializeMap()]));
        if (results.some(result => result.status === 'rejected')) {
          this.notifyService.showError('دریافت بخشی از اطلاعات داشبورد با خطا مواجه شد. دوباره تلاش کنید.');
        }
      }
    } finally {
      this.loading = false;
      this.otherService.nonespinner();
    }
  }

  private async getDomain(): Promise<void> {
    const response = await axios.post(
      'GetMobileDomain4Report?iSystemUser=' + this.gurdService.decrypt(localStorage.getItem('ID')!), {},
    );
    this.domain = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
  }

  private async getGroup(): Promise<void> {
    const response = await axios.post('GetMobileType', {});
    this.groupCar = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
  }

  private createReportModel(withDateRange: boolean) {
    return {
      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      iMobileDomain: this.iMobileDomain,
      tiMobileType: this.tiMobileType,
      ...(withDateRange ? {
        strSDate: this.dataFrom.controls['date'].value,
        strEDate: this.dataTo.controls['date'].value,
        strSTime: this.strSTime.value,
        strETime: this.strETime.value,
      } : {}),
    };
  }

  private async loadChart(
    chartKey: FisheriesChartKey, api: string, sessionError: string, withDateRange = false,
  ): Promise<void> {
    this[chartKey] = { ...this[chartKey], loading: true, error: undefined };
    try {
      const response = await axios.post(api, this.createReportModel(withDateRange));
      const data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
      if (data?.ISSessionExpired === true || data?.ISessionExpired === true) {
        this.notifyService.showError('لطفا وارد سیستم شوید');
        this.otherService.removeLocalStorage();
        void this.router.navigate(['login'], { queryParams: { error: sessionError } });
        return;
      }
      if (data?.iResult == 0) throw new Error(data.strError || 'دریافت اطلاعات نمودار با خطا مواجه شد.');
      const context = this[chartKey];
      this[chartKey] = context.type === 'tree'
        ? { ...context, data: parseChartTree(data) }
        : { ...context, data: parseCategoryChartData(data) };
    } catch (error) {
      this[chartKey] = { ...this[chartKey], error: 'دریافت اطلاعات نمودار با خطا مواجه شد. دوباره به روز رسانی کنید.' };
      throw error;
    } finally {
      this[chartKey] = { ...this[chartKey], loading: false };
    }
  }


  initializeMap = async () => {

    this.map?.dispose?.();
    this.layers = [];
    this.source = new VectorSource({ wrapX: false });

    this.vector = new VectorLayer({

      source: this.source,

    });

    if (this.bOfflineMap) {

      this.layers.push(

        new TileLayer({

          source: new XYZ({

            url: this.strMapUrl,

            attributions: 'Map data © RayanAndishehNasr' //

          }),

        })

      );

    }

    else {

      const styles = [

        'AerialWithLabelsOnDemand',

      ];

      let i, ii;

      for (i = 0, ii = styles.length; i < ii; ++i) {

        this.layers.push(
          new TileLayer({
            visible: false,
            preload: Infinity,
            source: new BingMaps({
              key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

              imagerySet: styles[i],
            }),

          }),
        );
      }

      this.layers.push(new TileLayer({ source: new OSM({}) }), this.vector)

    }
    if (this.map?.frameIndex_) {

      this.map.setTarget(null);

    }

    this.map = new Map({

      target: "test",

      view: new View({

        zoom: 4,

        center: olProj.fromLonLat(this.location)

      }),

      layers: this.layers

    });

    await this.clusterData();

  }

  clusterData = async () => {

    const model = this.createReportModel(false);
    const resp = await axios.post('Report_MobileCluster', model);

    const resParse = typeof resp.data === 'string' ? JSON.parse(resp.data) : resp.data;
    if (this.destroyed) return;

    if (resParse.iResult == 0) throw new Error(resParse.strError);

    if (resParse.ISSessionExpired === true || resParse.ISessionExpired === true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '36' } });

      return;
    }

    this.clustersLayer(resParse);

  }

  clustersLayer(data: any) {
    this.map.on('click', (e: any) => {
      if (e.dragging) {
        //...
        return;
      }

      var el = this.mapService.mapPointerMove(
        this.map.getEventPixel(e.originalEvent),
        this.map
      );
      this.showData(el);
      $("#link").click(() => {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');

      });
    });
    this.map.getView().on('propertychange', function (e: any) {
      var tooltip = $('#map_tooltip');
      tooltip.tooltip('hide');
    });
    // Cluster Source
    var clusterSource = new Cluster({
      distance: 40,
      source: new Vector()
    }) as any;

    // Addfeatures to the cluster
    let addFeatures = (nb: any) => {
      var ext = this.map.getView().calculateExtent(this.map.getSize());
      var features = [];

      for (var i = 0; i < data.length; ++i) {
        features[i] = new Feature({
          // new Point (this.mapService.transformCoordinates2([
          //   data[i].dLongitude,
          //   data[i].dLatitude])

          // ),
          // data: data,
          type: 'removable',
          geometry: new Point(this.mapService.transformCoordinates2([
            data[i].dLongitude,
            data[i].dLatitude])

          ),
          id_: data[i].strUnitId,
          data: {
            Id: data[i].strUnitId,
            strFullName: data[i].strFullName,
            strDate: data[i].strDate,
            strMobile: data[i].strMobile,
            strTime: data[i].strTime,
            strVehicleNo: data[i].strVehicleNo,
            strMobileType_strComment: data[i].strMobileType_strComment,


            // html: `${data[i].strFullName}`,
          },
        });
        features[i].set("id", i);
      }
      clusterSource.getSource().clear();
      clusterSource.getSource().addFeatures(features);


    }

    // Style for the clusters
    var styleCache = {} as any;
    function getStyle(feature: any, resolution: any) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
        var radius = Math.max(8, Math.min(size * 0.75, 20));
        var dash = (2 * Math.PI * radius) / 6;
        var dashs = [0, dash, dash, dash, dash, dash, dash];
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: "rgba(" + color + ",0.5)",
              width: 15,
              lineDash: dashs,
              lineCap: "butt"
            }),
            fill: new Fill({
              color: "rgba(" + color + ",1)"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
      }
      return style;
    }

    // Animated cluster layer
    var clusterLayer = new AnimatedCluster({
      //name: "Cluster",
      source: clusterSource,
      animationDuration: 700,
      // Cluster style
      style: getStyle
    });
    this.map.addLayer(clusterLayer);
    // add 2000 features
    addFeatures(2000);

    var style1 = new Style({
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(128,0,0,0.8)",
          width: 2
        }),
        fill: new Fill({
          color: "rgba(128,0,0,0.8)"
        })
      }),
      // Draw a link beetween points (or not)
      stroke: new Stroke({
        color: "#fff",
        width: 1
      })
    });
    // Select interaction to spread cluster out and select features
    var selectCluster = new SelectCluster({
      // Point radius: to calculate distance between the features
      pointRadius: 7,
      animate: true,
      // Feature style when it springs apart
      featureStyle: function () {
        return [style1];
      },
      // selectCluster: false,	// disable cluster selection
      // Style to draw cluster when selected
      style: function (f, res) {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getStyle(f, res);
        } else {
          return [
            new Style({
              image: new Circle({
                stroke: new Stroke({
                  color: "rgba(0,0,192,0.5)",
                  width: 2
                }),
                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                radius: 5
              })
            })
          ];
        }
      }
    });
    this.map.addInteraction(selectCluster);


  }

  showData(item: any) {
    var tooltip = $('#map_tooltip');
    tooltip.tooltip({
      html: true,
      animation: true,
      trigger: 'manual',
      placement: 'top',
    });
    tooltip.css({
      left: item.pixel[0] + 'px',
      top: item.pixel[1] - 14 + 'px',
      zindex: 1000,
    });
    if (item.featureLayer) {
      if (item.featureLayer.feature) {
        if (item.featureLayer.feature.values_.features.length == 1) {
          if (item.featureLayer.feature.values_.features[0].values_.data.strFullName) {
            // $('#carCluster').modal('show');
            // this.clusterModal = item.featureLayer.feature.values_.features[0].values_.data;

          }
        }

        // tooltip
        //   .attr(
        //     'data-bs-original-title',
        //     //item.featureLayer.feature.get('data').html
        //     '<div><h5>hello</h5></div>'
        //   )
        //   .tooltip('show');
        // $("#map-tooltips").click(() => {

        //   this.router.navigate([`/carInfo/${item.featureLayer.feature.get('data').Id}`]);
        //   tooltip.tooltip('hide');

        // });
      }
    } else {
      tooltip.tooltip('hide');
    }
  }

}
